import React from 'react';
import {actions, connect, render, Router, Route} from 'mirrorx';
import initializeModels from './models/models';
import registerServiceWorker from './registerServiceWorker';

import Layout from './components/layout';
import Filebar from './components/filebar';
import './index.css';
import './styles/style.css';

import KeyboardShortcuts from './singletons/keyboard';

import localforage from 'localforage';
import DropboxChooser from './singletons/dropbox-chooser-script';

import Pages from './enums/pages';
import DropboxRedirect from './singletons/dropbox-redirect';

initializeModels();

class App extends React.Component {
	
	componentDidMount() {
		
		localforage.getItem('rune-seen-tutorial').then(item => {
			if (!item) {
				actions.layout.setPage(Pages.TUTORIAL);
				return localforage.setItem('rune-seen-tutorial', true);
			}
		}).then(() => {
			// blank
		})

		// setup onunload listener.
		window.onbeforeunload = () => {
			if (this.props.editor.isDirty) {
				return 'Close without saving changes?';
			}
		};
	}

	renderMainApp() {
		return <div className='full-size'>
						<Filebar />
						<Layout />
						<KeyboardShortcuts />
						<DropboxChooser />
					</div>;
	}

	
	render() {
		return (
			<Router basename="/" hashType="hashbang">
				<div class='app'>
					<Route path="/redirect" component={DropboxRedirect} />
					<Route path="/" component={this.renderMainApp} />
				</div>
			</Router>
		)
	}
}

// connect state with component
const ReactApp = connect(state => {
  return {editor: state.editor,
  	services: state.services}
})(App);

// start the app，`render` is an enhanced `ReactDOM.render`
render(<ReactApp />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js